import { FC, useEffect, useState } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { RootPortal } from '../../../components/root-portal/index';
import { StringKey } from '../../../lang/index';

const texts: StringKey[] = [
  'SCENARIO_CAP_TABLE_LOADING_TEXT_1',
  'SCENARIO_CAP_TABLE_LOADING_TEXT_2',
  'SCENARIO_CAP_TABLE_LOADING_TEXT_3',
  'SCENARIO_CAP_TABLE_LOADING_TEXT_4',
  'SCENARIO_CAP_TABLE_LOADING_TEXT_5',
  'SCENARIO_CAP_TABLE_LOADING_TEXT_6',
];

export type CapTableLoaderProps = { isLoading: boolean; placement?: 'CUSTOM' | 'PORTAL' };

type LoaderProps = {
  text: StringKey;
};
const Loader: FC<LoaderProps> = ({ text }) => (
  <div className="centered flex h-fit w-[453px] flex-col gap-6 rounded-[4px] bg-white py-10 shadow-3xl">
    <div className="my-6 flex size-8 shrink-0 flex-wrap gap-[2px]">
      <div className="flex-[0_0_calc(50%-1px)] animate-blink bg-[#2565C8]" />
      <div className="flex-[0_0_calc(50%-1px)] animate-blink bg-[#2565C8] [animation-delay:1.5s]" />
      <div className="flex-[0_0_calc(50%-1px)] animate-blink bg-[#2565C8] [animation-delay:1.5s]" />
      <div className="flex-[0_0_calc(50%-1px)] animate-blink bg-[#2565C8]" />
    </div>
    <span className="text-sm font-[450px] text-gray-700">
      <AppFormattedMessage id={text} />
    </span>
  </div>
);

export const CapTableLoader: FC<CapTableLoaderProps> = ({ isLoading, placement = 'PORTAL' }) => {
  const [textIndex, setTextIndex] = useState(Math.floor(Math.random() * texts.length));

  const handelNextText = () => {
    setTextIndex((prev) => {
      const nextValue = prev + 1;
      if (nextValue > texts.length - 1) return 0;

      return nextValue;
    });
  };
  useEffect(() => {
    const interval = setInterval(handelNextText, 5_000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  if (!isLoading && placement === 'PORTAL') return;

  if (placement === 'CUSTOM') return <Loader text={texts[textIndex]} />;
  return (
    <RootPortal className="centered flex bg-black/20">
      <Loader text={texts[textIndex]} />;
    </RootPortal>
  );
};
